import React, { useContext, useEffect, useState } from 'react';

import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { get, isEmpty } from 'lodash';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import queryString from 'query-string';

import clsx from 'clsx';

import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

import BobPage from '../../../components/BobPage';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import GoogleLogo from '../../../components/GoogleLogo';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ContactViewSelector from '../../../components/ContactViewSelector';
import BobLoadingMask from '../../../components/BobLoadingMask';
import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import BobContactPhoneInput from '../../../components/BobContactPhoneInput';

import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

import * as ContactActions from '../../../actions/contactActions';
import * as ApplicationMessageActions from '../../../actions/applicationMessageActions';

import tableClasses from '../ClientPage/Table.module.css';
import containerClasses from '../ClientPage/ClientPage.module.css';
import classes from './ManageContactPage.module.css';
import SiteContactsContextMenu from './SiteContactsContextMenu';
import UpdateSiteContactPhoneModal from '../Modals/UpdateSiteContactPhoneModal';
import BobModal from '../../../components/BobModal';

const MyGridContext = React.createContext({});

const PhoneNumberCell = (props) => {
    const gridContext = useContext(MyGridContext);
    const { dataItem, dataIndex } = props;
    let phoneNumber = dataItem.phoneNumber;

    if (phoneNumber && phoneNumber.charAt(0) !== '+') {
        phoneNumber = '+' + phoneNumber;
    }

    const hasError = phoneNumber ? !isValidPhoneNumber(phoneNumber) : true;

    const key = dataItem.id ? dataItem.id : `PhoneCell-${dataIndex}`;

    const formattedPhoneNumber = () => {
        if (phoneNumber) {
            let formattedNumber = parsePhoneNumber(phoneNumber);
            if (formattedNumber) formattedNumber = formattedNumber.formatInternational();
            return formattedNumber;
        } else {
            return dataItem.phoneNumber;
        }
    };

    return (
        <td key={key}>
            <FormControl key={key}>
                {
                    props.dataItem.inEdit ?
                        <BobContactPhoneInput
                            key={key}
                            name="phoneNumber"
                            label="Phone Number"
                            data-cy="user-phone"
                            hasError={hasError}
                            defaultCode="us"
                            overrideHeight={true}
                            value={dataItem.phoneNumber}
                            onChange={
                                (v, d, e, fv) => {
                                    gridContext.handleFormChange('phoneNumber', v, dataIndex);
                                }
                            }
                            helperText={true && 'Invalid phone number.'}
                        />
                        :
                        formattedPhoneNumber()
                }
            </FormControl>
        </td>
    );
};

const ExtensionCell = props => {
    const gridContext = useContext(MyGridContext);
    const { dataItem, dataIndex } = props;

    return (
        <td key={props.dataItem.id}>
            <FormControl className={classes.Extension} key={props.dataItem.id}>
                {
                    props.dataItem.inEdit ?
                        <TextField
                            onChange={(event) => gridContext.handleFormChange('extension', event.target.value, dataIndex)}
                            id={`extension-${props.dataItem.id}`}
                            key={props.dataItem.id}
                            name="extension"
                            value={dataItem.extension}
                            type="text"
                            size="small"
                            variant="outlined"
                            inputProps={{ maxLength: 7 }}
                        />
                        :
                        dataItem.extension
                }
            </FormControl>
        </td>
    );
};

const ValidationSchema = Yup.object().shape({
    email: Yup.string()
        .required(),
    firstName: Yup.string()
        .required(),
    lastName: Yup.string()
        .required(),
    title: Yup.string()
        .required(),
    addressSearch: Yup.string()
        .required(),
    autoIncludeSite:      Yup.boolean(),
    clientAndSiteContact: Yup.boolean()
});

const ManageContactPage = ({
    activeNavClient,
    activeNavCompany,
    activeNavSite,
    bobLoading,
    confirmClientContactEmail,
    confirmSiteContactEmail,
    createClientContact,
    createContactPhoneNumber,
    deleteContact,
    enqueueSnackbar,
    fetchContactTitles,
    fetchContactsById,
    history,
    navSites,
    selectedContact,
    setSelectedContact,
    updateContact,
    ...props
}) => {
    const [address, setAddress] = useState({});
    const [titles, setTitles] = useState([]);

    const [address1, setAddress1] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    const [sort, setSort] = useState([]);
    const [view, setView] = useState('assigned');

    const [isLoading, setIsLoading] = useState(false);
    const [phoneNumbers, setPhoneNumbers] = useState([]);
    const [updatedPhoneNumbers, setUpdatedPhoneNumbers] = useState([]);
    const [inEditPhoneNumber, setInEditPhoneNumber] = useState({});
    const [sites, setSites] = useState([]);
    const [updateSiteContactPhoneModalOpen, setUpdateSiteContactPhoneModalOpen] = useState(false);
    const [phoneState, setPhoneState] = useState([]);
    const [contactBody, setContactBody] = useState({});
    const [modifiedNumbers, setModifiedNumbers] = useState([]);
  
    const [assignedSites, setAssignedSites] = useState([]);
    const [unassignedSites, setUnassignedSites] = useState([]);

    const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        if (isEmpty(selectedContact)) setView('unassigned');
    }, []);

    useEffect(() => {
        const init = async () => {
            if (queryValues.contactId && isEmpty(selectedContact)) {
                const contactList = await fetchContactsById(activeNavClient.id, queryValues.userId);
                const contact = contactList.find(item => item.id === queryValues.contactId);
                if (contact) setSelectedContact(contact);
            }

            const titles = await fetchContactTitles(activeNavCompany.id);
            setTitles(titles);
        };

        if (activeNavClient.id) init();
    }, [activeNavClient]);

    useEffect(() => {
        const init = async () => {
            if (!isEmpty(sites)) {
                //Extract site details
                const contactSites = await fetchContactsById(activeNavClient.id, selectedContact.userId);
                const assignedIds = contactSites.filter(item => item.siteId);

                const assignedSites = assignedIds.map(item => {
                    const obj = sites.find(o => o.id === item.siteId);
                    return { ...obj, ...item };
                });

                const unassignedSites = sites.filter(item => !assignedIds.map(item => item.siteId).includes(item.id));

                setAssignedSites(assignedSites);
                setUnassignedSites(unassignedSites);
            }

            //Extract phone numbers
            let phoneNumbers = [];

            selectedContact.userAssignmentPhones.forEach(item => {
                const number = {
                    id:          item.id,
                    phoneNumber: item.phoneNumber.number,
                    phoneType:   item.phoneNumber.phoneType,
                    extension:   item.phoneNumber.extension,
                    primary:     item.isPrimary,
                    SMS:         item.isSMS,
                    phoneId:     item.phoneNumber.id
                };

                phoneNumbers.push(number);
            });

            setPhoneNumbers(phoneNumbers);

            //Extract Geo Address
            handleGeocodeAddress(selectedContact.userAssignmentAddresses[0].address.formattedAddress);
        };

        if (!isEmpty(selectedContact)) init();
    }, [selectedContact, sites]);

    useEffect(() => {
        if (!isEmpty(navSites)) {
            if (isEmpty(sites)) {
                setSites(navSites);
            }
        }
    }, [navSites]);

    useEffect(() => {
        return () => {
            setSelectedContact({});
            setSites([]);
        };
    }, []);

    const formik = useFormik({
        initialValues: {
            email:                !isEmpty(selectedContact) ? selectedContact.email : '',
            firstName:            !isEmpty(selectedContact) ? selectedContact.userName.FirstName : '',
            lastName:             !isEmpty(selectedContact) ? selectedContact.userName.LastName : '',
            title:                !isEmpty(selectedContact) ? selectedContact.userAttributes.title : '',
            addressSearch:        '',
            autoIncludeSite:      !isEmpty(selectedContact) ? selectedContact.userAttributes.autoIncludeSite : false,
            clientAndSiteContact: false
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, {setSubmitting}) => {
            if (!isEmpty(inEditPhoneNumber)) {
                setIsMessageModalOpen(true);
            }
            else { 
                setIsLoading(true);

                const primaryNumber = phoneNumbers.find(item => item.primary === true);
                if (!isEmpty(phoneNumbers) && !primaryNumber) {
                    enqueueSnackbar('You must have a primary phone number.', 'error');
                    setIsLoading(false);
                    return;
                }

                const body = {
                    clientId:             activeNavClient.id,
                    siteId:               activeNavSite.id,
                    email:                values.email,
                    firstName:            values.firstName,
                    lastName:             values.lastName,
                    title:                values.title,
                    phoneNumbers:         [],
                    autoIncludeSite:      values.autoIncludeSite || false,
                    clientAndSiteContact: values.clientAndSiteContact || false
                };
                const siteContactChanges = [];

                if (isEmpty(selectedContact)) {
                    body.addresses = [{address: {...address}, isPrimary: true}];

                    phoneNumbers.forEach(number => {
                        body.phoneNumbers.push({
                            phoneNumber: {
                                number:    `+${ number.phoneNumber }`,
                                extension: number.extension,
                                phoneType: number.phoneType
                            },
                            isSMS:     number.SMS,
                            isPrimary: number.primary,
                        });
                    });
                } else {
                    body.phoneNumbers = [];
                    //find numbers to be deleted
                    selectedContact.userAssignmentPhones.forEach(number => {
                        const foundNumber = phoneNumbers.find(item => item.id === number.id);

                        if (!foundNumber) {
                            const data = {
                                isSMS:       typeof number.isSMS !== 'boolean' ? number.SMS : number.isSMS,
                                isPrimary:   typeof number.isPrimary !== 'boolean' ? number.primary : number.isPrimary,
                                phoneNumber: {
                                    number:    number.phoneNumber.number,
                                    extension: number.phoneNumber.extension,
                                    phoneType: number.phoneNumber.phoneType
                                },
                                phoneId:               number.phoneNumber.id,
                                operation:             'Delete',
                                userAssignmentPhoneId: number.id
                            };
                            body.phoneNumbers.push(data);
                            siteContactChanges.push(data);
                        }

                    });

                    //find numbers to be updated
                    phoneNumbers.forEach(number => {
                        const foundNumber = selectedContact.userAssignmentPhones.find(item => item.id === number.id);
                        if (foundNumber) {
                            if (number.SMS !== foundNumber.isSMS || number.primary !== foundNumber.isPrimary) {
                                body.phoneNumbers.push({
                                    isSMS:       number.SMS,
                                    isPrimary:   number.primary,
                                    phoneNumber: {
                                        number:    number.phoneNumber,
                                        extension: number.extension,
                                        phoneType: number.phoneType
                                    },
                                    operation:             'Update',
                                    phoneId:               foundNumber.phoneNumber.id,
                                    userAssignmentPhoneId: number.id
                                });
                            }
                        }
                    });

                    //find numbers to be created
                    phoneNumbers.forEach(number => {
                        const foundNumber = selectedContact.userAssignmentPhones.find(item => item.id === number.id);

                        if (!foundNumber && number.id) {
                            const data = {
                                isSMS:       number.SMS || false,
                                isPrimary:   number.primary || false,
                                phoneNumber: {
                                    number:    number.phoneNumber,
                                    extension: number.extension,
                                    phoneType: number.phoneType
                                },
                                operation: 'Create',
                                phoneId:   number.id,
                            };

                            body.phoneNumbers.push(data);
                            siteContactChanges.push(data);
                        }
                    });

                    body.addresses = [{address: {...address}, isPrimary: selectedContact.userAssignmentAddresses[0].isPrimary, userAssignmentAddressId: selectedContact.userAssignmentAddresses[0].id}];
                }

                if (!isEmpty(siteContactChanges) && !queryValues.site) {
                    setPhoneState(siteContactChanges);
                    setContactBody(body);
                    setUpdateSiteContactPhoneModalOpen(true);
                    setIsLoading(false);

                    return;
                } else {

                    try {
                        const isCreated = isEmpty(selectedContact) ? await createClientContact(activeNavCompany.id, body) : await updateContact(selectedContact.id, body);

                        if (isCreated) {
                            setIsLoading(false);
                            handleRoute();
                        }
                        setIsLoading(false);
                    } catch (error) {
                        setIsLoading(false);
                    }
                }
            }
        }
    });

    const handleRoute = () => {
        let path = '/v2/dashboard/client';
        const queryValues = queryString.parse(history.location.search);

        if (activeNavSite.id) {
            if (queryValues.appId === '1710345b-cf28-4a02-9bf4-df9209ff29cb') {
                path = '/v2/dashboard/core/entities';
            } else {
                path = '/v2/dashboard/site';
            }
        } else {
            if (queryValues.appId === '1710345b-cf28-4a02-9bf4-df9209ff29cb') path = '/v2/dashboard/core/entities';
        }

        let updatedUrl = history.location.search.replace(/[?&]contactId=[^&]+/, '').replace(/^&/, '?');
        updatedUrl = updatedUrl.replace(/[?&]userId=[^&]+/, '').replace(/^&/, '?');

        history.push({ pathname: path, search: updatedUrl });
    };

    const handleGeocodeAddress = async address => {
        try {
            const results = await geocodeByAddress(address);
            const latLng = await getLatLng(results[0]);

            const streetNumber = results[0].address_components.find(result => {
                return result.types.includes('street_number');
            });

            const route = results[0].address_components.find(result => {
                return result.types.includes('route');
            });

            const city = results[0].address_components.find(result => {
                return result.types.includes('locality');
            });

            const subLocality = results[0].address_components.find(result => {
                return result.types.includes('sublocality');
            });

            const administrativeAreaLevel2 = results[0].address_components.find(result => {
                return result.types.includes('administrative_area_level_2');
            });

            const administrativeAreaLevel3 = results[0].address_components.find(result => {
                return result.types.includes('administrative_area_level_3');
            });

            const state = results[0].address_components.find(result => {
                return result.types.includes('administrative_area_level_1');
            });

            const zip = results[0].address_components.find(result => {
                return result.types.includes('postal_code');
            });

            const country = results[0].address_components.find(result => {
                return result.types.includes('country');
            });

            const address1Check = streetNumber ? `${streetNumber.long_name} ${route.long_name}` : route.long_name;
            const cityCheck = city ? city.long_name : administrativeAreaLevel3 ? administrativeAreaLevel3.long_name : subLocality ? subLocality.long_name : '';

            formik.setFieldValue('addressSearch', results[0].formatted_address);

            setAddress1(address1Check);
            setCity(cityCheck);
            setState(state.short_name);
            setZip(zip.long_name);

            setAddress({
                latitude:                 get(latLng, 'lat', ''),
                longitude:                get(latLng, 'lng', ''),
                administrativeAreaLevel1: get(state, 'short_name', ''),
                administrativeAreaLevel2: get(administrativeAreaLevel2, 'long_name', ''),
                country:                  get(country, 'short_name', ''),
                locality:                 cityCheck,
                postalCode:               get(zip, 'long_name', ''),
                route:                    get(route, 'long_name', ''),
                streetNumber:             streetNumber ? streetNumber.long_name : '',
                formattedAddress:         get(results[0], 'formatted_address', '')
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error: ', error);
        }
    };

    const handleEdit = dataItem => {
        if (phoneNumbers.find(item => item.inEdit)) return;

        const updatedNumbers = [...phoneNumbers];

        setInEditPhoneNumber({ ...dataItem });
        updatedNumbers[updatedNumbers.findIndex(number => number.id === dataItem.id)].inEdit = true;
        setPhoneNumbers(updatedNumbers);
    };

    const handleCancelEdit = dataItem => {
        const updatedNumbers = [...phoneNumbers];

        if (!dataItem.id) {
            handleDelete(dataItem);
            return;
        }

        if (!isEmpty(inEditPhoneNumber)) {
            const index = updatedNumbers.findIndex(item => item.id === inEditPhoneNumber.id);
            updatedNumbers[index] = inEditPhoneNumber;
        }

        updatedNumbers[updatedNumbers.findIndex(number => number.id === dataItem.id)].inEdit = false;
        setPhoneNumbers(updatedNumbers);
        setInEditPhoneNumber({});
    };

    const handleDelete = dataItem => {
        let updatedPhoneData = [...phoneNumbers];
        let updatePhoneList = [...updatedPhoneNumbers];

        const foundNumber = updatePhoneList.findIndex(number => number.id === dataItem.id);

        if (foundNumber >= 0) {
            updatePhoneList[foundNumber].operation = 'Delete';
        } else {
            dataItem.operation = 'Delete';
            updatePhoneList = [...updatePhoneList];
            updatePhoneList.push(dataItem);
        }

        updatedPhoneData = updatedPhoneData.filter(number => number.id !== dataItem.id);

        if (dataItem.primary) {
            if (updatedPhoneData.length > 0) {
                updatedPhoneData[0].primary = true;
            }
        }

        setInEditPhoneNumber({});
        setPhoneNumbers(updatedPhoneData);
        setUpdatedPhoneNumbers(updatePhoneList);
    };

    const handleSavePhoneNumber = async dataItem => {
        //Check if number is valid before saving
        let number = dataItem.phoneNumber;
        if (number && number.charAt(0) !== '+') {
            number = '+' + number;
        }

        if (!dataItem.phoneNumber || !dataItem.phoneType || !isValidPhoneNumber(number)) return;

        //Creating a phone number
        if (!dataItem.id) {
            const body = {
                number:    dataItem.phoneNumber,
                extension: dataItem.extension,
                phoneType: dataItem.phoneType
            };
            const isCreated = await createContactPhoneNumber(body);

            if (isCreated) {
                const updatedPhoneNumbers = [...phoneNumbers];
                body.id = isCreated.id;
                dataItem.id = isCreated.id;

                updatedPhoneNumbers.push(body);
                setPhoneNumbers(updatedPhoneNumbers);
                handleCancelEdit(dataItem);
            }
        } else {
            if (dataItem.phoneNumber !== inEditPhoneNumber.phoneNumber || dataItem.phoneType !== inEditPhoneNumber.phoneType || dataItem.extension !== inEditPhoneNumber.extension) {
                //Update a phone number
                const body = {
                    number:    dataItem.phoneNumber,
                    extension: dataItem.extension,
                    phoneType: dataItem.phoneType
                };
                const isCreated = await createContactPhoneNumber(body);
                if (isCreated) {
                    const updatedPhoneNumbers = [...phoneNumbers];
                    body.id = isCreated.id;
                    dataItem.id = isCreated.id;

                    updatedPhoneNumbers.push(body);
                    setPhoneNumbers(updatedPhoneNumbers);
                    handleCancelEdit(dataItem);

                    let updatedModifiedNumbers = [...modifiedNumbers];
                    updatedModifiedNumbers.push({ old: inEditPhoneNumber, new: { ...dataItem, phoneId: isCreated.id } });
                    setModifiedNumbers([...updatedModifiedNumbers]);
                }
            }

            const updatedNumbers = [...phoneNumbers];

            updatedNumbers[updatedNumbers.findIndex(number => number.id === dataItem.id)].inEdit = false;
            setPhoneNumbers(updatedNumbers);
        }
    };

    const actionsCell = props => {
        const inEdit = props.dataItem.inEdit;

        return (
            <td>
                {
                    inEdit ?
                        <React.Fragment>
                            <span role="none" onClick={() => handleSavePhoneNumber(props.dataItem)} className={clsx('material-icons-outlined md-18', classes.ActionIcon)}>
                                save
                            </span>
                            <span role="none" onClick={() => handleCancelEdit(props.dataItem)} className={clsx('material-icons-outlined md-18', classes.ActionIcon)}>
                                clear
                            </span>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <span role="none" onClick={() => handleEdit(props.dataItem)} className={clsx('material-icons-outlined md-18', classes.ActionIcon)}>
                                edit
                            </span>
                            <span role="none" onClick={() => handleDelete(props.dataItem)} className={clsx('material-icons-outlined md-18', classes.ActionIcon)}>
                                delete
                            </span>
                        </React.Fragment>
                }
            </td>
        );
    };

    const sitesActionCell = props => {
        return (
            <td>
                {
                    isEmpty(selectedContact) ?
                        null
                        :
                        <SiteContactsContextMenu
                            view={view}
                            handleAssignSite={handleAssignSite}
                            handleUnassignSite={handleUnassignSite}
                            dataItem={props.dataItem}
                        />
                }
            </td>
        );
    };

    const isDisabled = () => {
        let disabled = false;
        phoneNumbers.forEach(number => {
            if (!number.phoneType || !number.phoneNumber || number.inEdit) {
                disabled = true;
            }
        });

        return disabled;
    };

    const handleAddPhoneNumber = () => {
        if (isDisabled()) return;
        const updatedPhoneData = [...phoneNumbers];
        if (!updatedPhoneData.length) {
            updatedPhoneData.unshift({ primary: true, SMS: false, inEdit: true });
        } else {
            updatedPhoneData.unshift({id: null, inEdit: true});
        }

        setInEditPhoneNumber({id: null, inEdit: true});
        setPhoneNumbers(updatedPhoneData);
    };

    const handleFormChange = (field, value, index) => {
        const updatedPhoneData = [...phoneNumbers];
        updatedPhoneData[index][field] = value;
        setPhoneNumbers(updatedPhoneData);
    };

    const handlePrimaryCheckbox = selectedPhone => {
        const isChecked = !selectedPhone.primary;
        let hydratedPhoneNumbers = [...phoneNumbers];

        //If another primary, unset it and set this as new primary
        const existingPrimary = hydratedPhoneNumbers.find(item => item.primary === true);
        let newUpdatedPhoneNumbers = [...phoneNumbers];

        const updateCheckboxes = () => {
            hydratedPhoneNumbers.forEach((item, index) => {
                //loop through entire list, look through updated list, if found, update the item otherwise add the item
                const foundNumber = newUpdatedPhoneNumbers.findIndex(number => number.id === item.id);

                if (foundNumber >= 0) {
                    if (newUpdatedPhoneNumbers[foundNumber].id === selectedPhone.id) {
                        newUpdatedPhoneNumbers[foundNumber].primary = true;
                    } else {
                        newUpdatedPhoneNumbers[foundNumber].primary = false;
                    }
                    newUpdatedPhoneNumbers[foundNumber].operation = 'Update';
                } else {
                    if (item.id === selectedPhone.id) {
                        item.primary = true;
                    } else {
                        item.primary = false;
                    }

                    item.operation = 'Update';
                    newUpdatedPhoneNumbers = [...newUpdatedPhoneNumbers];
                    newUpdatedPhoneNumbers.push(item);
                }
            });
        };

        if (existingPrimary) {
            if (isChecked) {
                updateCheckboxes();
                hydratedPhoneNumbers = phoneNumbers.map(item => item.id === selectedPhone.id ? { ...item, primary: isChecked } : { ...item, primary: false });
            }
        } else {
            if (isChecked) {
                updateCheckboxes();
                hydratedPhoneNumbers = phoneNumbers.map(item => item.id === selectedPhone.id ? { ...item, primary: isChecked } : { ...item, primary: false });
            }
        }

        //find and set or create in updatedNumbers array
        setUpdatedPhoneNumbers(newUpdatedPhoneNumbers);
        setPhoneNumbers(hydratedPhoneNumbers);
    };

    const handleSMSCheckbox = selectedPhone => {
        const isChecked = !selectedPhone.SMS;

        const hydratedPhoneNumbers = phoneNumbers.map(item => item.id === selectedPhone.id ? { ...item, SMS: isChecked } : item);

        setPhoneNumbers(hydratedPhoneNumbers);
    };

    const renderPrimaryCell = props => {
        const { dataItem } = props;
        const selectedPhone = phoneNumbers.find(number => number.id === dataItem.id);

        return (
            <td>
                <Checkbox onChange={() => handlePrimaryCheckbox(selectedPhone)} style={{ color: 'black', transform: 'scale(1.3)', paddingLeft: '13px' }} checked={selectedPhone.primary} />
            </td>
        );
    };

    const renderSmsCell = props => {
        const { dataItem } = props;
        const selectedPhone = phoneNumbers.find(number => number.id === dataItem.id);

        return (
            <td>
                <Checkbox onChange={() => handleSMSCheckbox(selectedPhone)} style={{ color: 'black', transform: 'scale(1.3)', paddingLeft: '13px' }} checked={selectedPhone.SMS} />
            </td>
        );
    };

    const phoneTypeCell = props => {
        const { dataItem, dataIndex } = props;

        return (
            <td>
                <FormControl
                    className={classes.PhoneType}
                    error={!dataItem.phoneType} v
                    ariant="outlined"
                    size="small"
                >
                    {
                        dataItem.inEdit ?
                            <Select
                                onChange={(event) => handleFormChange('phoneType', event.target.value, dataIndex)}
                                value={dataItem.phoneType}
                                id="title"
                                name="title"
                            >
                                <MenuItem
                                    key={0}
                                    value={'Landline'}
                                >
                                    Landline
                                </MenuItem>
                                <MenuItem
                                    key={1}
                                    value={'Fax'}
                                >
                                    Fax
                                </MenuItem>
                                <MenuItem
                                    key={2}
                                    value={'Pager'}
                                >
                                    Pager
                                </MenuItem>
                                <MenuItem
                                    key={3}
                                    value={'Mobile'}
                                >
                                    Mobile
                                </MenuItem>
                            </Select>
                            :
                            dataItem.phoneType
                    }
                </FormControl>
            </td>
        );
    };

    const renderSiteName = props => {
        

        const { dataItem } = props;
        if (view === 'assigned') {
            const linkPath = `/v2/dashboard/contacts?appId=ad356bf2-b9db-4bb5-922e-c3394b1a63e3&childId=f93bff85-c8cf-4dcf-a64a-a499b927c58b&client=${dataItem.clientId}&company=${dataItem.companyId}&contactId=${dataItem.id}&parentId=c0c505f5-c7fc-4317-8cb6-f6e631142a77&site=${dataItem.siteId}&userId=${dataItem.userId}`;
            return <td className={props.className} style={props.style}>
                <Link
                    to={linkPath}
                    target="_blank"
                >
                    {dataItem.name}
                </Link>
            </td>;
        }
        else {
            return <td className={props.className} style={props.style}>{dataItem.name}</td>;
        }
        
    };

    const renderSiteContactTitle = dataItem => {
        const titleId = dataItem.dataItem.userAttributes ? dataItem.dataItem.userAttributes.title : '';
        const title = titles.find(item => item.id === titleId);

        if (!isEmpty(title)) {
            return <td>{title.name}</td>;
        } else {
            return <td>{''}</td>;
        }
    };

    const renderSiteContactPrimary = dataItem => {
        const primaryNumber = dataItem.dataItem.userAssignmentPhones ? dataItem.dataItem.userAssignmentPhones.find(item => item.isPrimary === true) : '';

        if (!isEmpty(primaryNumber)) {
            let formattedNumber = parsePhoneNumber(primaryNumber.phoneNumber.number);
            if (formattedNumber) formattedNumber = formattedNumber.formatInternational();

            return <td>{formattedNumber}</td>;
        } else {
            return <td>{''}</td>;
        }
    };

    const renderSiteContactSMS = dataItem => {
        const SMSNumber = dataItem.dataItem.userAssignmentPhones ? dataItem.dataItem.userAssignmentPhones.find(item => item.isSMS === true) : '';

        if (!isEmpty(SMSNumber)) {
            let formattedNumber = parsePhoneNumber(SMSNumber.phoneNumber.number);
            if (formattedNumber) formattedNumber = formattedNumber.formatInternational();

            return <td>{formattedNumber}</td>;
        } else {
            return <td>{''}</td>;
        }
    };

    const handleAssignSite = async dataItem => {
        const body = {
            clientId:             activeNavClient.id,
            siteId:               dataItem.id,
            email:                formik.values.email,
            firstName:            formik.values.firstName,
            lastName:             formik.values.lastName,
            title:                formik.values.title,
            clientAndSiteContact: false,
            phoneNumbers:         [],
        };
        body.addresses = [{ address: { ...address }, isPrimary: true }];

        phoneNumbers.forEach(number => {
            body.phoneNumbers.push({
                phoneNumber: {
                    number:    `${number.phoneNumber}`,
                    extension: number.extension,
                    phoneType: number.phoneType
                },
                isSMS:     number.SMS,
                isPrimary: number.primary,
            });
        });

        await createClientContact(activeNavCompany.id, body);

        const contactSites = await fetchContactsById(activeNavClient.id, selectedContact.userId);
        const assignedIds = contactSites.filter(item => item.siteId);

        const assignedSites = assignedIds.map(item => {
            const obj = sites.find(o => o.id === item.siteId);
            return { ...obj, ...item };
        });

        const unassignedSites = sites.filter(item => !assignedIds.map(item => item.siteId).includes(item.id));

        setAssignedSites(assignedSites);
        setUnassignedSites(unassignedSites);
    };

    const handleUnassignSite = async dataItem => {
        await deleteContact(dataItem.id);

        const contactSites = await fetchContactsById(activeNavClient.id, selectedContact.userId);
        const assignedIds = contactSites.filter(item => item.siteId);

        const assignedSites = assignedIds.map(item => {
            const obj = sites.find(o => o.id === item.siteId);
            return { ...obj, ...item };
        });

        const unassignedSites = sites.filter(item => !assignedIds.map(item => item.siteId).includes(item.id));

        setAssignedSites(assignedSites);
        setUnassignedSites(unassignedSites);
    };

    const handleEmailOnBlur = async (event) => {
        let contact;

        if (queryValues.site) {
            contact = await confirmSiteContactEmail(activeNavClient.id, activeNavSite.id, { Email: event.target.value });
        } else {
            contact = await confirmClientContactEmail(activeNavClient.id, { Email: event.target.value });
        }

        if (!isEmpty(contact)) {
            const matchingContact = contact[0];
            setSelectedContact(matchingContact);

            const queryValues = queryString.parse(history.location.search);
            const { pathname } = history.location;
            queryValues.userId = matchingContact.userId;
            queryValues.contactId = matchingContact.id;

            const queryValueString = queryString.stringify(queryValues);
            history.push(`${pathname}?${queryValueString}`);
        }
    };

    return (
        <BobPage>
            <div className={containerClasses.ClientPage}>
                <div className={containerClasses.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={containerClasses.HeaderPanel}>
                    <div className={classes.NavigationPanel}>
                        <span onClick={() => handleRoute()} role="none" className={clsx('material-icons-outlined', classes.Icon)}>
                            chevron_left
                        </span>
                        {queryValues.site ? 'Site Contact' : 'Client Contact' }
                    </div>
                </div>
                <div className={classes.ContactPage}>
                    <div className={classes.ClientPanel}>
                        <div className={classes.PanelTitle}>
                            {
                                queryValues.site ?
                                    'Site Details'
                                    :
                                    'Client Details'
                            }
                        </div>
                        <div className={classes.EntityHeader}>
                            <div className={classes.ClientLabel}>
                                Client
                            </div>
                            <div className={classes.ClientName}>
                                {activeNavClient.name}
                            </div>
                            {
                                queryValues.site ?
                                    <React.Fragment>
                                        <div className={classes.SiteLabel}>
                                            Site
                                        </div>
                                        <div className={classes.SiteName}>
                                            {activeNavSite.name}
                                        </div>
                                    </React.Fragment>
                                    :
                                    null
                            }
                        </div>
                        <div className={classes.FormContainer}>
                            <FormControl className={classes.InputWrapper}>
                                <TextField
                                    disabled={!isEmpty(selectedContact)}
                                    id="email"
                                    name="email"
                                    type="text"
                                    value={formik.values.email}
                                    label={<span>Email Address<span className={classes.Required}> *</span></span>}
                                    size="small"
                                    onChange={formik.handleChange}
                                    InputLabelProps={{
                                        classes: {
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }
                                    }}
                                    InputProps={{
                                        onBlur:  handleEmailOnBlur,
                                        classes: {
                                            error:     classes.cssErrorUnderline,
                                            underline: classes.cssUnderline,
                                            root:      classes.input
                                        }
                                    }}
                                    variant="outlined"
                                    FormHelperTextProps={{
                                        classes: {
                                            error: classes.error
                                        }
                                    }}
                                    error={Boolean(formik.errors.email) && Boolean(formik.touched.email)}
                                />
                            </FormControl>
                            <FormControl className={classes.InputWrapperLeft}>
                                <TextField
                                    id="firstName"
                                    name="firstName"
                                    type="text"
                                    value={formik.values.firstName}
                                    label={<span>First Name<span className={classes.Required}> *</span></span>}
                                    size="small"
                                    onChange={formik.handleChange}
                                    InputLabelProps={{
                                        classes: {
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }
                                    }}
                                    InputProps={{
                                        onBlur:  formik.handleBlur,
                                        classes: {
                                            error:     classes.cssErrorUnderline,
                                            underline: classes.cssUnderline,
                                            root:      classes.input
                                        }
                                    }}
                                    variant="outlined"
                                    FormHelperTextProps={{
                                        classes: {
                                            error: classes.error
                                        }
                                    }}
                                    error={Boolean(formik.errors.firstName) && Boolean(formik.touched.firstName)}
                                />
                            </FormControl>
                            <FormControl className={classes.InputWrapperRight}>
                                <TextField
                                    id="lastName"
                                    name="lastName"
                                    type="text"
                                    value={formik.values.lastName}
                                    label={<span>Last Name<span className={classes.Required}> *</span></span>}
                                    size="small"
                                    onChange={formik.handleChange}
                                    InputLabelProps={{
                                        classes: {
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }
                                    }}
                                    InputProps={{
                                        onBlur:  formik.handleBlur,
                                        classes: {
                                            error:     classes.cssErrorUnderline,
                                            underline: classes.cssUnderline,
                                            root:      classes.input
                                        }
                                    }}
                                    variant="outlined"
                                    FormHelperTextProps={{
                                        classes: {
                                            error: classes.error
                                        }
                                    }}
                                    error={Boolean(formik.errors.lastName) && Boolean(formik.touched.lastName)}
                                />
                            </FormControl>
                            <FormControl variant="outlined" size="small" className={classes.InputWrapperLeft}>
                                <InputLabel
                                    htmlFor="title"
                                    error={Boolean(formik.errors.title) && Boolean(formik.touched.title)}
                                >
                                    {<span>Title<span className={classes.Required}> *</span></span>}
                                </InputLabel>
                                <Select
                                    value={formik.values.title}
                                    id="title"
                                    onChange={formik.handleChange}
                                    name="title"
                                    inputProps={{
                                        onBlur: formik.handleBlur
                                    }}
                                    error={Boolean(formik.errors.title) && Boolean(formik.touched.title)}
                                >
                                    {
                                        titles.map(title => (
                                            <MenuItem
                                                key={title.id}
                                                value={title.id}
                                            >
                                                {title.name}
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                            <FormControl className={classes.InputWrapperRight}>
                                {
                                    queryValues.site ?
                                        isEmpty(selectedContact) ?
                                            <FormControlLabel
                                                className={classes.CheckboxLabel}
                                                control={
                                                    <Checkbox
                                                        value="clientAndSiteContact"
                                                        name="clientAndSiteContact"
                                                        onChange={formik.handleChange}
                                                        checked={formik.values.clientAndSiteContact}
                                                        style={{ color: 'black', transform: 'scale(1.3)', paddingLeft: '13px' }}
                                                    />
                                                }
                                                label="Create client contact"
                                            />
                                            :
                                            null
                                        :
                                        !isEmpty(selectedContact) ?
                                            <FormControlLabel
                                                className={classes.CheckboxLabel}
                                                control={
                                                    <Checkbox
                                                        value="autoIncludeSite"
                                                        name="autoIncludeSite"
                                                        onChange={formik.handleChange}
                                                        checked={formik.values.autoIncludeSite}
                                                        style={{ color: 'black', transform: 'scale(1.3)', paddingLeft: '13px' }}
                                                    />
                                                }
                                                label="Include in all new sites"
                                            />
                                            :
                                            <FormControlLabel
                                                className={classes.CheckboxLabel}
                                                control={
                                                    <Checkbox
                                                        value="autoIncludeSite"
                                                        name="autoIncludeSite"
                                                        onChange={formik.handleChange}
                                                        checked={formik.values.autoIncludeSite}
                                                        style={{ color: 'black', transform: 'scale(1.3)', paddingLeft: '13px' }}
                                                    />
                                                }
                                                label="Include all sites"
                                            />
                                }
                            </FormControl>
                            <PlacesAutocomplete
                                value={formik.values.addressSearch}
                                onChange={address => formik.setFieldValue('addressSearch', address)}
                                onSelect={(handleGeocodeAddress)}
                            >
                                {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                                    <React.Fragment>
                                        <FormControl variant="outlined" size="small" className={classes.InputWrapper}>
                                            <TextField
                                                {...getInputProps({
                                                    name: 'addressSearch',
                                                    id:   'addressSearch'
                                                })}
                                                label={<span>Search for Address<span className={classes.Required}> *</span></span>}
                                                variant="outlined"
                                                size="small"
                                                error={Boolean(formik.errors.addressSearch) && Boolean(formik.touched.addressSearch)}
                                            />
                                        </FormControl>
                                        {suggestions.length > 0 && <Paper className={classes.AutoCompleteList}>
                                            <List>
                                                {suggestions.map((suggestion, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <ListItem
                                                                button
                                                                className={classes.AutoCompleteListItem}
                                                                {...getSuggestionItemProps(suggestion)}
                                                            >
                                                                <ListItemText primary={suggestion.description} />
                                                            </ListItem>
                                                        </div>
                                                    );
                                                })}
                                            </List>
                                            <GoogleLogo />
                                        </Paper>}
                                    </React.Fragment>
                                )}
                            </PlacesAutocomplete>
                            <FormControl className={classes.InputWrapper}>
                                <TextField
                                    id="address1"
                                    name="address1"
                                    type="text"
                                    value={address1}
                                    label="Address"
                                    disabled
                                    size="small"
                                    variant="outlined"
                                />
                            </FormControl>
                            <FormControl className={classes.InputWrapperLeft}>
                                <TextField
                                    id="city"
                                    name="city"
                                    type="text"
                                    value={city}
                                    label="City"
                                    disabled
                                    size="small"
                                    variant="outlined"
                                />
                            </FormControl>
                            <FormControl className={classes.StateInputWrapper}>
                                <TextField
                                    id="state"
                                    name="state"
                                    type="text"
                                    value={state}
                                    label="State"
                                    disabled
                                    size="small"
                                    variant="outlined"
                                />
                            </FormControl>
                            <FormControl className={classes.ZipInputWrapper}>
                                <TextField
                                    id="zip"
                                    name="zip"
                                    type="text"
                                    value={zip}
                                    label="Zip Code"
                                    disabled
                                    size="small"
                                    variant="outlined"
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className={classes.SitePanel}>
                        {
                            !queryValues.site ?
                                <React.Fragment>
                                    <div className={classes.PanelTitle}>
                                        Site Details
                                        <span className={classes.ViewSelector}>
                                            <ContactViewSelector
                                                view={view}
                                                handleChangeView={setView}
                                            />
                                        </span>
                                    </div>
                                    <div>
                                        <Grid
                                            sortable
                                            sort={sort}
                                            onSortChange={(e) => {
                                                setSort(e.sort);
                                            }}
                                            scrollable="none"
                                            className={tableClasses.ContactGrid}
                                            data={isEmpty(selectedContact) && view === 'unassigned' ? sites : view === 'assigned' ? assignedSites : unassignedSites}
                                            selectable={{
                                                enabled: true,
                                                drag:    false,
                                                cell:    false,
                                                mode:    'multiple'
                                            }}
                                            reorderable
                                        >
                                            <Column
                                                field="name"
                                                title={'Site'}
                                                width="350px"
                                                cell={renderSiteName}
                                            />
                                            {
                                                view === 'assigned' ?
                                                    <Column
                                                        field="title"
                                                        title="Title"
                                                        width="auto"
                                                        cell={renderSiteContactTitle}
                                                    />
                                                    :
                                                    null
                                            }
                                            {
                                                view === 'assigned' ?
                                                    <Column
                                                        field="primaryPhone"
                                                        title="Primary Number"
                                                        width="auto"
                                                        cell={renderSiteContactPrimary}
                                                    />
                                                    :
                                                    null
                                            }
                                            {
                                                view === 'assigned' ?
                                                    <Column
                                                        field="sms"
                                                        title="SMS Number"
                                                        width="auto"
                                                        cell={renderSiteContactSMS}
                                                    />
                                                    :
                                                    null
                                            }
                                            <Column
                                                field=""
                                                title=""
                                                width="200px"
                                                cell={sitesActionCell}
                                            />
                                        </Grid>
                                    </div>
                                </React.Fragment>
                                :
                                null
                        }
                    </div>
                    <div className={classes.PhonePanel}>
                        {
                            bobLoading.includes('CreatePhoneNumber') ?
                                <BobLoadingMask
                                    override={classes.Loader}
                                />
                                :
                                null
                        }
                        <div className={classes.PhonePanelTitle}>
                            Phone Details
                            <span className={classes.ViewSelector}>
                                <Button onClick={() => handleAddPhoneNumber()} style={{ textTransform: 'none' }} className={classes.Button}>
                                    <span className="material-icons-outlined md-18">
                                        add
                                    </span>
                                    <span className={classes.Text}>
                                        Add New
                                    </span>
                                </Button>
                            </span>
                        </div>
                        <div>
                            <MyGridContext.Provider value={{ handleFormChange: handleFormChange }}>
                                <Grid
                                    sortable
                                    sort={sort}
                                    onSortChange={(e) => {
                                        setSort(e.sort);
                                    }}
                                    scrollable="none"
                                    className={tableClasses.PhoneGrid}
                                    data={phoneNumbers}
                                    reorderable
                                    editField="inEdit"
                                >
                                    <Column
                                        field="phoneType"
                                        title="Phone Type"
                                        width="70px"
                                        cell={phoneTypeCell}
                                    />
                                    <Column
                                        field="phoneNumber"
                                        title="Phone Number"
                                        width="390px"
                                        cell={PhoneNumberCell}
                                    />
                                    <Column
                                        field="extension"
                                        title="Extension"
                                        width="auto"
                                        cell={ExtensionCell}
                                    />
                                    <Column title="Primary" width="50px" cell={renderPrimaryCell} />
                                    <Column title="SMS" width="50px" cell={renderSmsCell} />
                                    <Column
                                        field=""
                                        title=""
                                        width="200px"
                                        cell={actionsCell}
                                    />
                                </Grid>
                            </MyGridContext.Provider>
                        </div>
                    </div>
                    <div className={classes.ButtonPanel}>
                        <BobCancelButton
                            className={classes.CancelButton}
                            disabled={isLoading}
                            onClick={() => handleRoute()}
                            label={'Cancel'}
                        />
                        <BobConfirmButton
                            className={classes.Buttons}
                            onClick={formik.handleSubmit}
                            label={isEmpty(selectedContact) ? 'Create' : 'Save'}
                            iconSize={15}
                            isLoading={isLoading}
                        />
                    </div>
                </div>
                {
                    bobLoading.includes('FetchTitles') ||
                    bobLoading.includes('FetchSiteContact') ||
                    bobLoading.includes('FetchClientContacts') ||
                    bobLoading.includes('FetchSiteContacts') ||
                    bobLoading.includes('DeleteContact') ||
                    bobLoading.includes('CreateContact') ||
                    (queryValues.contactId && isEmpty(selectedContact)) ?
                        <BobLoadingMask />
                        :
                        null
                }
                {
                    updateSiteContactPhoneModalOpen ?
                        <UpdateSiteContactPhoneModal
                            assignedSites={assignedSites}
                            phoneState={phoneState}
                            contactBody={contactBody}
                            updatedPhoneNumbers={modifiedNumbers}
                            setUpdateSiteContactPhoneModalOpen={setUpdateSiteContactPhoneModalOpen}
                            selectedContact={selectedContact}
                            handleRoute={handleRoute}
                        />
                        :
                        null
                }
                {
                    isMessageModalOpen ?
                        <BobModal
                            onConfirm={() => setIsMessageModalOpen(false)}
                            title={'Save Phone Number'}
                            cancelable={false}
                            confirmText={'OK'}
                        >
                            <div style={{fontSize: '1.4rem'}}>
                                {'The contact phone number must be saved prior to saving the contact record.'}
                            </div>
                        </BobModal>
                        : null
                }
            </div>
        </BobPage>
    );
};

const mapStateToProps = state => {
    return {
        activeNavClient:  state.bob.activeNavClient,
        activeNavCompany: state.bob.activeNavCompany,
        activeNavSite:    state.bob.activeNavSite,
        bobLoading:       state.bob.bobLoading,
        navSites:         state.bob.navSites,
        selectedContact:  state.contact.selectedContact
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...ContactActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageContactPage));
